module.exports = __webpack_public_path__ + "static/media/appius_firma.c949d6fe.png";